"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "lanuvio": {
    "acc40618": [{
      "hkey": "a9dbcbdb",
      "slug": "lanuvio",
      "name": "Lanuvio",
      "primary": true,
      "skipSearch": false
    }],
    "farnete": [{
      "hkey": "a9dbcbdb",
      "slug": "lanuvio",
      "name": "Lanuvio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "0f969b85": [{
      "hkey": "a9dbcbdb",
      "slug": "lanuvio",
      "name": "Lanuvio",
      "primary": true,
      "skipSearch": false
    }],
    "malcavallo": [{
      "hkey": "a9dbcbdb",
      "slug": "lanuvio",
      "name": "Lanuvio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "67e8dd73": [{
      "hkey": "a9dbcbdb",
      "slug": "lanuvio",
      "name": "Lanuvio",
      "primary": true,
      "skipSearch": false
    }],
    "piano-marano": [{
      "hkey": "a9dbcbdb",
      "slug": "lanuvio",
      "name": "Lanuvio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;